import React from 'react';
import { PageSelect, PageSizeSelectButton } from './components';
import { SetPage, SetPageSize } from './interfaces';
import { getRowsRange, INITIAL_PAGE_SIZES } from './lib';
import { DropdownPlacement } from '@shared/UI';
import './Paginator.scss';

export interface PaginatorProps {
    page: number;
    pageSize: number;
    setPageSize: SetPageSize;
    setPage: SetPage;
    pageCount: number;
    totalCount: number;
    /** default: [5, 10, 20, 30, 40, 50]*/
    pageSizes?: number[];
    /** default: 'top'*/
    dropdownPlacement?: DropdownPlacement;
}

export const Paginator: React.FC<PaginatorProps> = (props) => {
    const {
        pageSize,
        pageSizes = INITIAL_PAGE_SIZES,
        setPageSize,
        setPage,
        totalCount,
        page,
        pageCount,
        dropdownPlacement = 'top-left',
    } = props;

    return (
        <div className='feature-paginator'>
            <PageSizeSelectButton
                pageSize={pageSize}
                pageSizes={pageSizes}
                setPageSize={setPageSize}
                setPage={setPage}
                dropdownPlacement={dropdownPlacement}
            />
            <PageSelect
                page={page}
                setPage={setPage}
                pageCount={pageCount}
            />
        </div>
    );
};
